module.exports = __webpack_public_path__ + "static/img/tab4.fe003dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCode/tab4.png
// module id = itV0
// module chunks = 0